import { Space, SpaceVertical, Tooltip } from '@looker/components';
import { BIIcon, BIIncludeExcludeListItem } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { FC } from 'react';
import { StyledAccordion } from './styles';

interface AwaitingListsAccordionProps {
  awaitingData: Record<string, { listName: string; listAlias?: string; url?: string }[]>;
}

export const AwaitingListsAccordion: FC<AwaitingListsAccordionProps> = ({ awaitingData }) => {
  const noopHandler = () => {};

  const renderLabel = (groupName: string) => (
    <Space gap="xsmall" align="center">
      <DsTypography>{groupName}</DsTypography>
      <Tooltip content="Lists are being processed and will be available within 2 hours">
        <BIIcon icon="Info" />
      </Tooltip>
    </Space>
  );

  return (
    <SpaceVertical gap="u2">
      {Object.entries(awaitingData).map(([groupName, items]) => (
        <StyledAccordion key={groupName} label={renderLabel(groupName)} defaultOpen={true} indicatorPosition="left">
          <SpaceVertical gap="u1">
            {items.map((item) => (
              <BIIncludeExcludeListItem
                key={item.listName}
                category={item.listName}
                onToggleCategory={noopHandler}
                disabledBlocking={true}
                disabledChecking={true}
              />
            ))}
          </SpaceVertical>
        </StyledAccordion>
      ))}
    </SpaceVertical>
  );
};
